import { Header } from "../components/sections/Header";
import { Hero } from "../components/sections/Hero";
import { Services } from "../components/sections/Services";
import { HowItWorks } from "../components/sections/HowItWorks";
import { Contact } from "../components/sections/Contact";
import { Footer } from "../components/sections/Footer";

export function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Services />
        <HowItWorks />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
